export type GmbPostFields = {
  gmbTopicType?: string;
  gmbEvent?: object | null;
  gmbOffer?: object | null;
  gmbCallToAction?: object | null;
};

function withoutUndefinedValues(fields: object | null | undefined) {
  return Object.fromEntries(
    Object.entries(fields ?? {}).filter(([, value]) => value !== undefined)
  );
}

export function mergeGmbPostFields<
  TBase extends object,
  TOverride extends object | null | undefined,
>(base: TBase, override: TOverride) {
  const overrideFields = override ?? {};

  return {
    ...base,
    ...overrideFields,
    gmbEvent: {
      ...((base as GmbPostFields).gmbEvent ?? {}),
      ...withoutUndefinedValues((overrideFields as GmbPostFields).gmbEvent),
    },
    gmbOffer: {
      ...((base as GmbPostFields).gmbOffer ?? {}),
      ...withoutUndefinedValues((overrideFields as GmbPostFields).gmbOffer),
    },
    gmbCallToAction: {
      ...((base as GmbPostFields).gmbCallToAction ?? {}),
      ...withoutUndefinedValues(
        (overrideFields as GmbPostFields).gmbCallToAction
      ),
    },
  };
}
